import { lazy } from "../utils";
import { canPlay } from "../patterns";
import HlsPlayer from "./HlsPlayer";
import FilePlayer from "./FilePlayer";

export interface PlayerConfig {
  key: string;
  name: string;
  canPlay: (url: string) => boolean;
  canEnablePIP?: (url: string) => boolean;
  lazyPlayer?: any;
}

const players: PlayerConfig[] = [
  {
    key: "hls",
    name: "HLS Player",
    canPlay: canPlay.hls,
    lazyPlayer: lazy(() => Promise.resolve({ default: HlsPlayer })),
  },
  {
    key: "file",
    name: "File Player",
    canPlay: canPlay.file,
    canEnablePIP: (url: string) => {
      return (
        canPlay.file(url) &&
        (document.pictureInPictureEnabled ||
          typeof (document as any).webkitSupportsPresentationMode ===
            "function")
      );
    },
    lazyPlayer: lazy(() => Promise.resolve({ default: FilePlayer })),
  },
];

export default players;
